import styled from 'styled-components';

export const ErrorMessage = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
`;
